import {
    GETPAYMENTMODELIST_SUCCESS,
    GETPAYMENTMODELIST_FAILED,
    RESET_GETPAYMENTMODELIST,
    LOADING_GETPAYMENTMODELIST,
    NETWORK_ERROR_GETPAYMENTMODELIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETPAYMENTMODELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETPAYMENTMODELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETPAYMENTMODELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETPAYMENTMODELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETPAYMENTMODELIST:
            return (state = initialState);
        default:
            return state;
    }
};
